'use client';

import React from 'react';
import { createMobileAwareClickHandler } from '@/helpers/mobile-redirect';
import { StyledCtaBanner } from './HeadingStructureTool.styles';
import { trackEvent } from '@/lib/track';

export const CtaBanner = () => {
  return (
    <StyledCtaBanner>
      <div className="banner-inner">
        <h2>Ready to add structure to every page?</h2>
        <p>
          Clean headings organize your page for crawlers. A free Common Ninja Accordion organizes it for readers, collapsing long sections into something scannable. No code.
        </p>
        <a
          className="banner-cta"
          href="/accordion/editor"
          onClick={createMobileAwareClickHandler(() => {
            try {
              trackEvent('tool_bridge_click', {
                tool: 'heading-structure-analyzer',
                placement: 'banner',
                target: 'accordion-editor',
              });
            } catch (err) {
              /* analytics must never block the click */
            }
          }, '/accordion/editor')}
        >
          Build my accordion, free &rarr;
        </a>
      </div>
    </StyledCtaBanner>
  );
};
